import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useLocation } from '@thd-olt-component-react/router';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { useConfigService } from '@thd-nucleus/experience-context';
import { EXP_ROUTES } from '../../../utils/constants';

const URLS = {
  HOME: { label: 'Home', url: '/' },
  LANDING: { label: 'Path to Pro Network', url: EXP_ROUTES.LANDING },
  SEARCH: { label: 'Candidate Search', url: EXP_ROUTES.CANDIDATE_SEARCH },
  DASHBOARD: { label: 'My Dashboard', url: EXP_ROUTES.MY_DASHBOARD },
  CREATE_JOB_POSTING: { label: 'Create Job Posting', url: EXP_ROUTES.CREATE_JOB_POSTING },
  JOB_POSTINGS: { label: 'Job Postings', url: EXP_ROUTES.JOB_POSTINGS },
  JOB_TEMPLATES: { label: 'Job Templates', url: EXP_ROUTES.JOB_TEMPLATES },
  COMPANY_PROFILE: { label: 'Company Profile', url: EXP_ROUTES.COMPANY_PROFILE },
  JOB_APPLICANTS: (jobPostingId) => ({ label: 'Job Applicants', url: EXP_ROUTES.JOB_APPLICANTS(jobPostingId) }),
  JOB_TEMPLATE: (jobTemplateId) => ({ label: 'Job Template', url: EXP_ROUTES.JOB_TEMPLATE(jobTemplateId) }),
  SEARCH_PROFILE: (candidateId) => ({ label: 'Profile Details', url: EXP_ROUTES.SEARCH_PROFILE(candidateId) }),
  DASHBOARD_PROFILE: (candidateId) => ({ label: 'Profile Details', url: EXP_ROUTES.DASHBOARD_PROFILE(candidateId) }),
  APPLICANTS_PROFILE: (jobPostingId, candidateId) => ({ label: 'Profile Details', url: EXP_ROUTES.APPLICANTS_PROFILE(jobPostingId, candidateId) })
};

const CRUMBS = (jobPostingId = null, candidateId = null, jobTemplateId = null) => ({
  [EXP_ROUTES.LANDING]: [URLS.HOME, URLS.LANDING],
  [EXP_ROUTES.LANDING2]: [URLS.HOME, URLS.LANDING],
  [EXP_ROUTES.CANDIDATE_SEARCH]: [URLS.HOME, URLS.LANDING, URLS.SEARCH],
  [EXP_ROUTES.MY_DASHBOARD]: [URLS.HOME, URLS.LANDING, URLS.DASHBOARD],
  [EXP_ROUTES.CREATE_JOB_POSTING]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS, URLS.CREATE_JOB_POSTING],
  [EXP_ROUTES.JOB_TEMPLATES]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS, URLS.JOB_TEMPLATES],
  [EXP_ROUTES.JOB_TEMPLATE(jobTemplateId)]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS, URLS.JOB_TEMPLATE(jobTemplateId)],
  [EXP_ROUTES.COMPANY_PROFILE]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS, URLS.COMPANY_PROFILE],
  [EXP_ROUTES.JOB_APPLICANTS(jobPostingId)]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS, URLS.JOB_APPLICANTS(jobPostingId)],
  [EXP_ROUTES.SEARCH_PROFILE(candidateId)]: [URLS.HOME, URLS.LANDING, URLS.SEARCH, URLS.SEARCH_PROFILE(candidateId)],
  [EXP_ROUTES.DASHBOARD_PROFILE(candidateId)]: [URLS.HOME, URLS.LANDING, URLS.DASHBOARD, URLS.DASHBOARD_PROFILE(candidateId)],
  [EXP_ROUTES.APPLICANTS_PROFILE(jobPostingId, candidateId)]: [URLS.HOME, URLS.LANDING, URLS.DASHBOARD, URLS.JOB_APPLICANTS(jobPostingId), URLS.APPLICANTS_PROFILE(jobPostingId, candidateId)],
  [EXP_ROUTES.JOB_POSTINGS]: [URLS.HOME, URLS.LANDING, URLS.JOB_POSTINGS]
});

/**
 * Check if string contain "/" at the end and rid of it
 * @param {String} str
 * @returns {String} string
 */
const trimSlash = (str) => {
  return str.length > 1 && str.substr(-1) === '/' ? str.substr(0, str.length - 1) : str;
};

const P2pBreadcrumbs = () => {
  const location = useLocation();
  const [crumbs, setCrumbs] = useState([]);

  const NewSplashPage = useConfigService('fs:NewSplashPage');

  const getJobPostingIdFromLocationPath = (path) => {
    const params = path.split('/');
    if (params.includes('applicants')) {
      return params[params.indexOf('applicants') + 1];
    }
  };

  const getCandidateIdFromLocationPath = (path) => {
    const params = path.split('/');
    if (params.includes('profile')) {
      return params[params.indexOf('profile') + 1];
    }
  };
  const getJobTemplateIdFromLocationPath = (path) => {
    const params = path.split('/');
    if (params.includes('job-templates')) {
      return params[params.indexOf('job-templates') + 1];
    }
  };

  useEffect(() => {
    const path = trimSlash(location.pathname);
    const jobPostingId = getJobPostingIdFromLocationPath(path);
    const candidateId = getCandidateIdFromLocationPath(path);
    const jobTemplateId = getJobTemplateIdFromLocationPath(path);

    setCrumbs(CRUMBS(jobPostingId, candidateId, jobTemplateId)[path]);
  }, [location]);

  return (
    <QueryProvider cacheKey="path-to-pro-network">
      {NewSplashPage ? (
        <div style={{ padding: '16px 24px' }}>
          <Breadcrumbs staticCrumbs={crumbs} useStencilDesign />
        </div>
      ) : (
        <Row>
          <Col>
            <Breadcrumbs staticCrumbs={crumbs} useStencilDesign />
          </Col>
        </Row>
      )}
    </QueryProvider>
  );
};

export default P2pBreadcrumbs;
